var map = {
	"./de.json": 47773,
	"./en.json": 80792,
	"@freshsolutions/fresh-vue-files/src/locale/de.json": 47773,
	"@freshsolutions/fresh-vue-files/src/locale/en.json": 80792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96009;